import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'jsd-core',
    templateUrl: './core.component.html',
    styleUrl: './core.component.scss'
})
export class CoreComponent {

    private menuOpen: boolean = false;

    menuToggle() {
        this.menuOpen = !this.menuOpen;
    }

    getMenuOpen() {
        return this.menuOpen;
    }

    menuCLose() {
        this.menuOpen = false;
    }
}
